export default __webpack_public_path__ + "static/media/memories-Text.74e162ca.png";